import Card from './Card.jsx'
import ProgressBar from './ProgressBar.jsx'
import { formatNumber } from '../../utils/formatters.js'

export default function StatCard({ icon: Icon, label, value, detail, approved, tone = 'default' }) {
  const total = Number(value || 0)
  return (
    <Card className={`stat-card stat-card-${tone}`}>
      <div className="stat-card-heading"><span>{label}</span>{Icon && <span className="stat-icon"><Icon aria-hidden="true" /></span>}</div>
      <strong className="stat-value">{formatNumber(total)}</strong>
      <p className="stat-detail">{detail}</p>
      {approved !== undefined && total > 0 && <ProgressBar value={approved} max={total} label={`${formatNumber(approved)} approved`} />}
    </Card>
  )
}
